import React from "react";
import LocalizationContext from "../utils/LocalizationContext";
import NavBar from "../components/NavBar";
import LicenseProduct from "../pages/LicenseProduct";
import useMenu from "../utils/Hooks/useMenu";
import ValidateURL from "../utils/ValidateURL";

export default () => {
  const menu = useMenu();
  const currentPage = {
    menuGroup: menu?.License,
    key: "LicenseProduct",
  };

  return (
    <ValidateURL currentPage={currentPage}>
      <LocalizationContext.Provider value={{}}>
        <NavBar
          MenuOptions={menu}
          currentPage={currentPage}
        >
          <LicenseProduct />
        </NavBar>
      </LocalizationContext.Provider>
    </ValidateURL>
  );
};
